import { render } from "./TaskCreate.vue?vue&type=template&id=d3ffcb38"
import script from "./TaskCreate.vue?vue&type=script&lang=js"
export * from "./TaskCreate.vue?vue&type=script&lang=js"
script.render = render

export default script